// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { IAddEntityModalParameters } from '../models/AddEntityModalParameters';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../styles/ButtonTextStyle';
import '../../../../../Content/css/theme/kanban.css';
interface AddNewEntityDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateEntity: (input: string) => void;
  onCreateEntities: (input: string[]) => void;
  modalParameters: IAddEntityModalParameters;
}

const AddNewEntityDialog: React.FC<AddNewEntityDialogProps> = ({
  isOpen,
  onClose,
  onCreateEntity,
  onCreateEntities,
  modalParameters,
}) => {
  const [input, setInput] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [buttonText, setButtonText] = useState('');
  const [showAdditionalButton, setShowAdditionalButton] = useState(false);

  useEffect(() => {
    const entitiesNames = input.split('\n').filter((i) => i.length > 0);
    if (entitiesNames.length > 1 && modalParameters.addEntitiesButtonPlaceholder) {
      setButtonText(
        modalParameters.addEntitiesButtonPlaceholder.replace('#', entitiesNames.length.toString())
      );
      setShowAdditionalButton(true);
    } else {
      setShowAdditionalButton(false);
      if (entitiesNames[0]?.length > 0) {
        setIsButtonDisabled(false);
      } else {
        setIsButtonDisabled(true);
      }
    }
  }, [input]);

  const handleAddEntity = () => {
    onCreateEntity(input);
    setIsButtonDisabled(true);
    setInput('');
    onClose();
  };

  const handleAddEntities = () => {
    const entitiesNames = input.split('\n').filter((t) => t.length !== 0);
    onCreateEntities(entitiesNames);
    setInput('');
    onClose();
  };

  const handleClose = () => {
    setInput('');
    onClose();
  };

  return (
    modalParameters && (
      <Dialog
        open={isOpen}
        onClose={handleClose}
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '100%',
              maxWidth: '452px',
              borderRadius: '10px',
            },
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: '20px',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 1,
          }}
        >
          {modalParameters.headerPlaceholder}
          <IconButton onClick={handleClose} size="small" aria-label="close">
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <input
            autoFocus
            id="name"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="dialog-textinput"
            placeholder={modalParameters.textPlaceholder}
          />
        </DialogContent>
        <ThemeProvider theme={theme}>
          <DialogActions sx={{ gap: 1 }}>
            <Button
              sx={{ flex: 1 }}
              variant="contained"
              color="info"
              onClick={handleAddEntity}
              disabled={isButtonDisabled}
            >
              {modalParameters.addEntityButtonPlaceholder}
            </Button>
            {showAdditionalButton && (
              <Button sx={{ flex: 1 }} variant="contained" onClick={handleAddEntities} color="info">
                {buttonText}
              </Button>
            )}
            <Button sx={{ flex: 1 }} variant="outlined" color="inherit" onClick={handleClose}>
              {modalParameters.cancelEntityButtonPlaceholder}
            </Button>
          </DialogActions>
        </ThemeProvider>
      </Dialog>
    )
  );
};

export default AddNewEntityDialog;
